import { Typography } from '@shared/ui/typography/typography';
import { Button } from '@vtbhome/juicyfront';
import React from 'react';
import { ModalBody, ModalFooter } from './modal-confirm.styles';
import { ModalConfirmProps } from './types';
import { CardDeclineRequest } from '@shared/ui/card-decline-request/card-decline-request';
import { AllLike } from '@vtbhome/juicyfront/indexIcon';
import { useApproveRequestMutation } from '@features/request/decline-manager-request/api/request-api';
import { CACHE_KEY_REQUEST_APPROVE } from '../../config/api-constants';
import { Modal } from '@shared/ui/modal/modal';
import { usePrefetchProduct } from '@entities/product/api/product-api';
import { usePrefetchOrder } from '@entities/order/api/order-api';
import { listOrdersInProductParameters } from '@shared/lib/utils/list-orders-in-product-parameters/list-orders-in-product-parameters';
import { useCurrentUserSelector } from '@entities/current-user/model/selectors';

export const ModalConfirm: React.FC<ModalConfirmProps> = ({ isShow, request, onClose, onConfirm }) => {
    const user = useCurrentUserSelector();
    const [approveRequest, approveRequestResult] = useApproveRequestMutation({
        fixedCacheKey: CACHE_KEY_REQUEST_APPROVE,
    });

    const prefetchProduct = usePrefetchProduct('productShortInfo', { ifOlderThan: 300 });
    const prefetchOrder = usePrefetchOrder('ordersList', { ifOlderThan: 300 });

    const handlePrefetch = () => {
        const productId = request.product.id;
        prefetchProduct(productId);
        prefetchOrder(
            listOrdersInProductParameters({
                productId,
                user,
            })
        );
    };

    const handleConfirm = async () => {
        await approveRequest(request.id);
        onConfirm();
    };

    return (
        <Modal
            size='l'
            isShow={isShow}
            showLine={false}
            header={<Typography size='h5'>Одобрение запроса</Typography>}
            footer={
                <ModalFooter>
                    <Button
                        disabled={approveRequestResult.isLoading}
                        type='button'
                        buttonType='light'
                        size='l'
                        onClick={onClose}>
                        Отменить
                    </Button>
                    <Button
                        disabled={approveRequestResult.isLoading}
                        preloader={approveRequestResult.isLoading}
                        type='submit'
                        buttonType='primary'
                        size='l'
                        startAdornment={AllLike}
                        onClick={handleConfirm}>
                        Подтвердить
                    </Button>
                </ModalFooter>
            }
            onClose={onClose}>
            {/* TODO: привязать продукт когда поменяется ответ request   сбэка */}
            <ModalBody>
                <Typography size='body1_long'>Вы действительно хотите одобрить регистрацию на этот продукт?</Typography>
                <CardDeclineRequest
                    request={request}
                    product={request.product}
                    user={request.user}
                    onPrefetchProduct={handlePrefetch}
                />
            </ModalBody>
        </Modal>
    );
};
